var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimpar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "limpar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-894.000000, -1097.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(812.000000, 1042.000635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97,63 C97,59.15 93.85,56 90,56 C86.15,56 83,59.15 83,63 C83,66.85 86.15,70 90,70 C93.85,70 97,66.85 97,63 Z M88,65 L92,61 M92,65 L88,61",
    id: "limpar"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimpar);
export default __webpack_public_path__ + "static/media/limpar.947452d4a51d1de773a38507c78b8586.svg";
export { ForwardRef as ReactComponent };